import { State } from "pages/Rules/Form/context/types";

const isAttachmentFilter = (state: State, type: "action" | "target") => {
  const { type: ruleType, rule } = state;
  const { targetType } = rule;

  if (type === "target") return false;

  return (
    (ruleType === "COPY_EMAILS" && targetType !== "EMAIL_FLOW") ||
    ruleType === "MOVE_EMAILS" ||
    ruleType === "DRAG_AND_DROP"
  );
};

/**
 * Temporary Hold and Request Approval act on the email as a whole, so their
 * action filter decides whether the rule runs at all: only emails carrying an
 * attachment that matches gets processed. Naming it "Action Filters" led users
 * to read the section as optional (MXH-5760), hence the attachment wording and
 * its own tooltip — the one used for attachment processing says the opposite,
 * that the rule still executes when nothing matches.
 */
const isAttachmentActionFilter = (state: State, type: "action" | "target") => {
  if (type === "target") return false;

  return state.type === "SEND_DELAY" || state.type === "REQUEST_APPROVAL";
};

export const getFilterTranslations = (
  state: State,
  type: "action" | "target"
) => {
  const translations = {
    title: `filters.${type}`,
    tooltip: "filters.actionTooltip",
    addButton: "addFilters",
  };

  if (isAttachmentFilter(state, type)) {
    translations.title = `filters.attachments`;
    translations.tooltip = "filters.attachmentsTooltip";
  }

  if (isAttachmentActionFilter(state, type)) {
    translations.title = `filters.attachments`;
    translations.tooltip = "filters.attachmentActionTooltip";
    translations.addButton = "addAttachmentFilters";
  }

  return translations;
};
